import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const errorFullPageGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const code = route.queryParamMap.get('code');
  const navigation = router.getCurrentNavigation();
  const isRefresh = !navigation?.previousNavigation;

  if (code === '401' && isRefresh) {
    window.location.href = '/login';
    return false;
  }

  return true;
};
